export default __webpack_public_path__ + "static/RichardColburn-3dcc251212089cfae0ec6d7e82a52993.jpg";